import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Button from 'components/Button/Button';
import IdentificationStatusEmpty from './IdentificationStatusEmpty';
import { IdentificationStatusProps } from './types';
import s from './IdentificationStatus.module.scss';
import getIcon from './getIcon';

function getDataTest(statusType?: string) {
  switch (statusType) {
    case 'identityStatus':
      return 'welcome_back.identity_status.button';
    case 'bankAccountStatus':
      return 'welcome_back.bank_account_status.button';
    default:
      return '';
  }
}

export default function IdentificationStatus({
  statusType,
  title,
  description,
  type,
  navigateTo,
  isLoaded = false,
}: IdentificationStatusProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!isLoaded) return <IdentificationStatusEmpty />;

  return (
    <div className={s.status}>
      {getIcon(type, s.icon)}
      <div className="flex-1">
        <h2 className={s.title}>{title}</h2>
        {description && (
          <p
            dangerouslySetInnerHTML={{ __html: description }}
            className={s.text}
          />
        )}
        {navigateTo && statusType && (
          <Button
            onClick={() => navigate(navigateTo)}
            className={s.button}
            dataTest={getDataTest(statusType)}
          >
            {t('common:continue')}
          </Button>
        )}
      </div>
    </div>
  );
}
